import React from "react";
import { Box, Flex, type FlexboxProps, type SpaceProps } from "@chakra-ui/react";
import { type FeaturedOutcome } from "contexts/cdp-industry-context";

export type OutcomeChipProps = FeaturedOutcome & SpaceProps & FlexboxProps;

export function OutcomeChip({ icon: Icon, color, title, ...props }: OutcomeChipProps) {
  return (
    <Flex
      bg="brand.background.light"
      borderRadius="small"
      p="smaller"
      maxW="240px"
      textStyle={{ base: "caption2", sm: "caption1" }}
      fontWeight="semibold"
      boxShadow="lg"
      align="center"
      gap="20px"
      {...props}
    >
      <Box borderRadius="full" bg={`new.${color}.150`} p="10px">
        <Icon color={`new.${color}.900`} boxSize="icon.lg" />
      </Box>

      {title}
    </Flex>
  );
}
